export default "__VITE_ASSET__BBOM_IK1__"